import styles from './index.css';

import * as React from 'react';
import classNames from 'classnames';

type TTypeIconProps = {
    icon: string;
    className?: string;
};
export default ({icon, className}: TTypeIconProps) => (
    <div className={classNames(styles.typeIcon, className)}>
        <img src={icon}/>
    </div>
);
